import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import {
  IBannerData,
  IConsentLetters,
  ISurgicalData,
} from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import {
  fetchConsentLetters,
  fetchScarRevision,
  fetchScarRevisionBanner,
} from "../../api/SurgicalDomainApi";

const ScarRevision = () => {
  const { setLoading } = useLoader();
  const [scarRevisionBanner, setScarRevisionBanner] = useState<IBannerData[]>(
    []
  );
  const [scarRevisionData, setScarRevisionData] = useState<ISurgicalData[]>([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchScarRevisionBanner(),
      fetchScarRevision(),
      fetchConsentLetters(),
    ])
      .then(
        ([scarRevisionBannerData, scarRevisionData, consentLettersData]) => {
          setScarRevisionBanner(scarRevisionBannerData);
          setScarRevisionData(scarRevisionData);
          // setArchiveVideoData(videoData);
          setConsentLetters(consentLettersData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      )
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={scarRevisionBanner}
        page={"Scar Revision"}
      />
      <SurgicalDomainsDescription descriptionData={scarRevisionData} consentLetters={consentLetters} surgicalName='Scar_Revision'/>
    </>
  );
};

export default ScarRevision;
